export default {
  authenticated (state, userData) {
    state.user.authenticated = true
    state.user.userObj = userData.user
    state.user.username = userData.username
    state.user.newUser = null
  },
  signout (state) {
    state.user.authenticated = false
    state.user.userObj = null
    state.user.username = null
    state.user.newUser = null
    state.user.userGroups = []
  },
  setNewUser (state, username) {
    state.user.newUser = username
  },
  setUserGroups (state, groups) {
    state.user.userGroups = groups
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js